import React, {
  PropsWithChildren,
  ComponentPropsWithoutRef,
  ReactElement,
} from 'react';
import classnames from 'classnames';
import { stopEventBubbling } from '../../../../utils/events';

export type ButtonColours =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'dark'
  | 'ghost'
  | 'link';

export type ButtonsSizes = 'default' | 'small' | 'large' | 'wide';

export type ButtonProps = Omit<ComponentPropsWithoutRef<'button'>, 'color'> &
  PropsWithChildren<{
    className?: string;
    size?: ButtonsSizes;
    colour?: ButtonColours;
    testId?: string;
  }>;

export function Button({
  children,
  className = '',
  colour = 'default',
  size = 'default',
  onClick,
  testId,
  ...rest
}: ButtonProps): ReactElement {
  const classes = classnames(
    'btn',
    `btn--${size}`,
    `btn--${colour}`,
    className,
  );

  return (
    <button
      {...rest}
      onClick={onClick ? stopEventBubbling(onClick) : undefined}
      className={classes}
      data-testid={testId}
    >
      {children}
    </button>
  );
}
